// Contains Octopus-specific SlickGrid editors
var promptedImage = require('../../img/variables/prompted.png');
var certificateImage = require('../../img/variables/certificate.png');

(function ($) {

  function OctopusVariableStateFormatter(row, cell, value, columnDef, dataContext) {
    if(value && value.icon)
    {
      return "<i class='fa fa-lg fa-"+value.icon+" "+ value.class + "' title='"+value.title+"'></i>";
    }
    
    if (value === "New") {
      return "<i class='fa fa-lg fa-asterisk text-warning' title='This variable has been added'></i>";
    } else if (value === "Changed") {
      return "<i class='fa fa-lg fa-pencil text-primary' title='This variable has been modified'></i>";
    } else if (value === "Deleted") {
      return "<i class='fa fa-lg fa-remove text-danger' title='When you save, this variable will be deleted'></i>";
    } else {
      return "<i class='fa fa-lg fa-check text-success' title='This variable has not been modified'></i>";
    }
  }

  function escapeVariableValue(string) {
    if (string === null) {
      return "";
    }
    var subs = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': '&quot;',
      "'": '&apos;',
      "/": '&#x2F;'
    };

    var esc = String(string).replace(/[&<>"'\/]/g, function (s) {
      return subs[s];
    });

    return esc.replace(/\n/g, '<strong style="color: #CCC">&para;</strong>');
  }

  function OctopusVariableValueFormatter(row, cell, value, columnDef, dataContext) {
    var result;
    if (dataContext.isSensitive) {
      result = "●●●●●●●●●●";
    } else {
      result = escapeVariableValue(dataContext.value);
    }

    if (dataContext.prompt && dataContext.prompt.label) {
      return "<img src='" + promptedImage + "' alt='This value will be entered at deployment time' width='16' height='16' /> " + result;
    } else {
      return result;
    }
  }

  function OctopusVariableValueAsyncPostRender(cellNode, row, dataContext, colDef) {

      // If the variable is a Certificate, and we are not in edit mode (that's the innerHTML !== dataContext.value hack)
      // then asynchronously fetch the certificate and render a nicer representation than simply the ID.

      if (dataContext.type !== 'Certificate' ||
           cellNode.innerHTML !== dataContext.value) {
        return;
      }

    var element = angular.element(cellNode);
    var octopusRepository = element.injector().get('octopusRepository');
    octopusRepository.Certificates.get(dataContext.value).then(function(certificate){
        // The href is empty because the click event is handled globally in grid.onClick.subscribe()
        element.html('<a href=javascript:;><img src="' + certificateImage + '" height="16" width="16" alt="Certificate" title="Certificate"/> ' + escapeVariableValue(certificate.Name) + '</a>');

        if (certificate.Archived) {
           element.append(' <i class="text-warning fa fa-warning" title="This certificate has been archived" data-toggle="tooltip" data-placement="right"></i>');
           element.find('[data-toggle="tooltip"]').tooltip();
        }
    });
  }

  var textEditTemplateString = '<variable-value-editor></variable-value-editor>';
  var certificateEditTemplateString = '<button class="enter-to-edit">Press enter to change certificate</button>';
  var linkTextEditTemplate;

  function OctopusVariableValueEditor(args) {
     this.scope = {};
     var inlineEditor;

     // Compile the angular template once only
     if (!linkTextEditTemplate) {
       linkTextEditTemplate =  angular.element(args.container).injector().get("$compile")(textEditTemplateString);
     }

    this.init = function () {
       var element = angular.element(args.container);
        this.scope = element.scope();
        this.scope.gridArgs = args;
        this.scope.state = {};
        this.scope.original = {};
        this.scope.container = $(args.container);
    };

    this.destroy = function () {
      $("#dynamicallyGeneratedContent").empty();
      $(args.container).empty();
      inlineEditor = null;
    };

    this.serializeValue = function () {
     return {
        value: (this.scope.state.value || '').trim(),
        prompt: this.scope.state.prompt,
        isSensitive: this.scope.state.isSensitive,
        type: this.scope.state.type
      };
    };

    this.applyValue = function (item, state) {
      item.value = state.value;
      item.isSensitive = state.isSensitive;
      item.prompt = state.prompt;
      item.type = state.type;
    };

    this.loadValue = function (item) {
        this.scope.state.value = this.scope.original.value = item.value;
        this.scope.state.prompt = this.scope.original.prompt = item.prompt;
        this.scope.state.isSensitive = this.scope.original.isSensitive = item.isSensitive;
        this.scope.state.type = this.scope.original.type = item.type;


        if (item.type && item.type === "Certificate") {

            inlineEditor = $(certificateEditTemplateString)
                .appendTo(args.container)
                .keydown(this.handleKeyDown)
                .click(function(){
                    showEditor();
                });

            this.focus();
        } else {
            $(linkTextEditTemplate(this.scope)).appendTo($("#dynamicallyGeneratedContent"));
        }
    };

     function showEditor() {
         var scope = this.scope;

         var controller = angular.element(args.container).scope();
         controller.showValueEditor(function (result) {
             if (result) {
                 scope.state = result;
                 args.commitChanges();
             }
         });
     }

     this.showEditor = showEditor;

    this.handleKeyDown = function (e) {
      if (e.which === $.ui.keyCode.ENTER) {
          e.stopImmediatePropagation();
          return true;
      } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
          e.preventDefault();
          args.grid.navigatePrev();
          return false;
      } else if (e.keyCode === $.ui.keyCode.TAB) {
          e.preventDefault();
          args.grid.navigateNext();
          return false;
      }
  };

    this.isValueChanged = function () {
        return (!(this.scope.state.value === "" && this.scope.original.value === null)) && (this.scope.state.value !== this.scope.original.value) || this.scope.state.isSensitive !== this.scope.original.isSensitive || angular.toJson(this.scope.state.prompt) !== angular.toJson(this.scope.original.prompt);
    };

    this.validate = function () {
      return {
        valid: true
      };
    };

    this.focus = function() {
        if (inlineEditor) {
            inlineEditor.focus();
        }
    };

    this.init();
  }

  function OctopusVariableScopeToString(scope, variableSettings) {
    if (!scope) {
      return "";
    }

    var fields = [];

    _.chain(variableSettings.scopeOptions).map(function (a) { return a; }).reverse().each(function(option) {
      var valueDictionary = {};

      _.each(option.values, function(v) {
        valueDictionary[v.id] = v.name;
      });

      if (scope[option.name] && scope[option.name].length > 0) {
        var selected = [];
        _.each(scope[option.name], function(selection) {
          selected.push(valueDictionary[selection]);
        });
        fields.push(selected.join(", "));
      }
    });
    
    return fields.join("; ");
  }

  function OctopusVariableScopeFormatter(row, cell, value, columnDef, dataContext) {
    return OctopusVariableScopeToString(value, columnDef.variableSettings);
  }

  function OctopusVariableScopeEditor(args) {
    var columnDef = args.column;
    //var variableSettings = columnDef.variableSettings;

    var self = this;

    var inlineEditor;
    var modifiedScope = {};
    var originalScope;

    this.init = function () {
      var editorTemplate = args.isFilter ?
          '<button class="variable-scope-editor filter">Show all</button>' :
          '<button class="variable-scope-editor enter-to-edit" >Press enter to edit scope</button>';

      inlineEditor = $(editorTemplate)
        .appendTo(args.container)
        .keydown(self.handleKeyDown)
        .click(function () {
          var controller = angular.element(args.container).scope();
          controller.showScopePicker(modifiedScope, args.isFilter, function(result){
            if(result) {
              modifiedScope = result;
              self.save();
            }
            inlineEditor.focus();
          });
        });

      self.focus();
    };

    this.handleKeyDown = function (e) {
      if (e.which === $.ui.keyCode.ENTER) {
        e.stopImmediatePropagation();
        return true;
      } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        args.grid.navigatePrev();
        return false;
      } else if (e.keyCode === $.ui.keyCode.TAB) {
        e.preventDefault();
        args.grid.navigateNext();
        return false;
      }
    };

    this.save = function () {
      args.commitChanges();
    };

    this.cancel = function (e) {
      if (e) {
        e.preventDefault();
      }
      args.cancelChanges();
      return false;
    };

    this.destroy = function () {
      $(args.container).empty();
    };

    this.focus = function () {
      inlineEditor.focus();
    };

    this.serializeValue = function () {
      return modifiedScope;
    };

    this.applyValue = function (item, state) {
      item.scope = state;
    };

    this.loadValue = function (item) {
      modifiedScope = item.scope;
      originalScope = item.scope;
    };

    this.isValueChanged = function () {
      if (_.difference(Object.keys(modifiedScope), Object.keys(originalScope)).length !== 0
      || _.difference(Object.keys(originalScope), Object.keys(modifiedScope)).length !== 0) {
        return true;
      }

      for(var prop in modifiedScope) {
        if(_.difference(modifiedScope[prop], originalScope[prop]).length !== 0
        || _.difference(originalScope[prop], modifiedScope[prop]).length !== 0) {
          return true;
        }
      }
      return false;
    };

    this.validate = function () {
      return {
        valid: true
      };
    };

    this.init();
  }

  function OctopusVariableSourceFormatter(row, cell, value, columnDef, dataContext) {
    return value ? "<a href='#"+value.link + "'>" + value.name + "</a>" : "";
  }

  $.extend(true, window, {
    "Slick": {
      "Editors": {
        "OctopusVariableValue": OctopusVariableValueEditor,
        "OctopusVariableScope": OctopusVariableScopeEditor
      },
      "Formatters": {
        "OctopusVariableValue": OctopusVariableValueFormatter,
        "OctopusVariableState": OctopusVariableStateFormatter,
        "OctopusVariableScope": OctopusVariableScopeFormatter,
        "OctopusVariableSource": OctopusVariableSourceFormatter
      },
      "Helpers": {
        "OctopusVariableScopeToString": OctopusVariableScopeToString
      },
      "AsyncPostRenderers" : {
        "OctopusVariableValueAsyncPostRender": OctopusVariableValueAsyncPostRender
      }
    }
  });
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/ui/slick.octopus.js
// module id = 741869620362328
// module chunks = 1